module.exports = __webpack_public_path__ + "img/solutions3.e9b6d283.png";